import _ from 'lodash';
import { createSelector } from 'reselect';
import { getEntityByName } from '../appEntities';
import {
    PAYOUT_ACCOUNTS_FAILURE,
    PAYOUT_ACCOUNTS_LOAD,
    PAYOUT_ACCOUNTS_SUCCESS
} from './payoutAccountActions';

export function payoutAccountsMapper(action) {
    let payoutAccounts = _.sortBy(_.get(action, 'payoutAccounts', []), ['name']);

    return payoutAccounts.reduce((acc, item) => {
        acc[item.payoutAccountId] = item.name;

        return acc;
    }, {});
}

export default function reducer(state = {
    payoutAccountMap: {},
    payoutAccounts: []
}, action = {}) {
    let newState;

    switch (action.type) {
        case PAYOUT_ACCOUNTS_LOAD:
            newState = {
                ...state,
                error: null,
                loaded: false,
                loading: true,
                payoutAccounts: []
            };

            return _.isEqual(state, newState) ? state : newState;

        case PAYOUT_ACCOUNTS_SUCCESS:
            newState = {
                ...state,
                loaded: true,
                loading: false,
                payoutAccountMap: payoutAccountsMapper(action),
                payoutAccounts: _.sortBy(action.payoutAccounts, ['name'])
            };

            return _.isEqual(state, newState) ? state : newState;

        case PAYOUT_ACCOUNTS_FAILURE:
            newState = {
                ...state,
                error: action.error,
                loaded: true,
                loading: false,
                payoutAccounts: []
            };

            return _.isEqual(state, newState) ? state : newState;
        default:
            return state;
    }
}

export const getPayoutAccountEntity = createSelector(
    (state) => state,
    (state) => getEntityByName(state, 'payoutAccounts')
);

export const getIsPayoutAccountsLoaded = createSelector(
    getPayoutAccountEntity,
    (entity) => _.get(entity, 'loaded')
);

export const getIsPayoutAccountsLoading = createSelector(
    getPayoutAccountEntity,
    (entity) => _.get(entity, 'loading')
);

export const getPayoutAccounts = createSelector(
    getPayoutAccountEntity,
    (entity) => _.get(entity, 'payoutAccounts')
);

export const getPayoutAccountByPayoutAccountId = createSelector(
    getPayoutAccounts,
    (state, payoutAccountId) => (payoutAccountId),
    (payoutAccounts, payoutAccountId) => (
        payoutAccounts.find((payoutAccount) => (payoutAccount.payoutAccountId === payoutAccountId))
    )
);

export const getIsPayoutProviderConfigured = createSelector(
    getPayoutAccountByPayoutAccountId,
    (payoutAccount) => _.get(payoutAccount, 'isPayoutConfigured')
);

export const getPayoutAccountsThatRequireBatchReview = createSelector(
    getPayoutAccounts,
    (payoutAccounts) => _.filter(payoutAccounts, 'shouldReviewBatch')
);

export const getPayoutAccountsError = createSelector(
    getPayoutAccountEntity,
    (entity) => _.get(entity, 'error')
);

export const getPayoutAccountsErrorMessage = createSelector(
    getPayoutAccountsError,
    (error) => _.get(error, 'message')
);

// TODO this?
export const getPayoutAccountsMapper = createSelector(
    getPayoutAccountEntity,
    (entity) => _.get(entity, 'payoutAccountMap')
);
